import { Http} from "../Http";
export class SessionAPI {
  public static sessionLogin(input: any) {
    var obj = JSON.stringify(input);
    var url = "/api/session";
    var source = {
      userId: input.userId,
      password: input.password
    };
     obj = JSON.stringify(source);
    var obJSon = JSON.parse(obj);
    if (input.userId !== null && input.userId !== "") {
      const resultMethod = Http.axios()
        .post(url, obJSon, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(res => {
       
          return res;
        })
        .catch((e: any) => {
      
          return e.response;
        });
      return resultMethod;
    }
  }
  public static sessionCheck(input: any) {
    var obj = JSON.stringify(input);
    var url = "/api/sessionval";
    var source = {
      userId: input.userId,
      password: input.password
    };
     obj = JSON.stringify(source);
    var obJSon = JSON.parse(obj);
    if (input.userId !== null && input.userId !== "") {
      const resultMethod = Http.axios()
        .post(url, obJSon, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
          }
        })
        .then(res => {
           
          return res;
        })
        .catch((e: any) => {
         
          return e.response;
        });
      return resultMethod;
    }
  }
}
